var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('back-to-home'),_c('h1',[_vm._v("Mitglied Anlegen")]),_c('v-spacer'),_c('submit-form',{attrs:{"is-create":true},on:{"submit":_vm.onSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }